import styled from '@bd/bdui-styles/emotion';
import FilterBar from '@bd/bdui-filterbar';
import { colors } from '../styles';

export default styled(FilterBar)`
  position: relative;
  z-index: 1;
  .FilterBar_wrapper {
    width: 100%;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
    }
  }
  .FilterBar_list {
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: top;
    @media(min-width: 992px) {
      display: flex;
      box-shadow: none;
    }
    .FilterBar_listItem {
      width: 100%;
      flex-shrink: 0;
      font-weight: 800;
      font-size: 16px;
      margin: 0 0 10px 0;
      @media(min-width: 992px) {
        margin: 0;
        width: auto;
        flex: 1;
        &:last-child {
          .FilterSelect_title {
            margin: 0;
          }
        }
      }
    }
  }
  .FilterSelect_title {
    padding: 0 70px 0 25px;
    cursor: pointer;
    line-height: 40px;
    display: block;
    position: relative;
    font-weight: 700;
    font-size: 15px;
    text-transform: uppercase;
    border: 1px solid ${colors.neutralDarkest};
    border-radius: 8px;
    margin: 0 0 0 0;
    @media(min-width: 992px) {
      line-height: 55px;
      margin: 0 15px 0 0;
    }
    &::after {
      content: '';
      border-top: 7px solid ${colors.brand2};
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 18px;
    }
    &:focus {
      outline: none;
    }
  }
  .FilterSelect_dropdown {
    position: relative;
    list-style: none;
    padding: 0 10px 20px;
    min-width: 200px;
    width: 100%;
    max-height: 400px;
    overflow: scroll;
    background-color: ${colors.white};
    z-index: 1;
    @media(min-width: 992px) {
      box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
      position: absolute;
      max-width: 280px;
      max-height: 700px;
      padding: 15px 0 20px;
    }
  }
  .FilterSelect_dropdownItem {
    font-weight: 400;
    font-size: 16px;
    color: ${colors.body};
    width: 100%;
    position: relative;
    padding-left: 25px;
    @media(min-width: 992px) {
      font-size: 14px;
      color: ${colors.body};
      letter-spacing: 0;
      line-height: 26px;
      border: 0;
      white-space: nowrap;
    }
    &:last-child {
      border: 0;
    }
  }
  .FilterSelect_dropdownItemButton {
    padding: 10px 0 10px 5px;
    display: inline-block;
    cursor: pointer;
    width: calc(100% - 30px);
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 28px;
    text-transform: capitalize;
    @media(min-width: 992px) {
      font-size: 15px;
      padding: 3px 0;
      color: ${colors.brand3};
    }
  }
  .FilterSelect_dropdownItemCheckbox {
    text-rendering: optimizeSpeed;
    width: 15px;
    height: 15px;
    margin: 15px 0 0;
    margin-right: 1px;
    display: block;
    float: left;
    position: relative;
    cursor: pointer;
    @media(min-width: 992px) {
      top: -4px;
      right: 4px;
    }
    &::after {
      content: "";
      vertical-align: middle;
      text-align: center;
      line-height: 13px;
      position: absolute;
      cursor: pointer;
      height: 15px;
      width: 15px;
      left: 0;
      top: 0;
      font-size: 10px;
      box-shadow: inset 0 1px 1px ${colors.white}, 0 1px 0 ${colors.white};
      background: ${colors.neutral};
      transition: all .1s ease-out;
    }
    &:hover::after, &:checked:hover::after {
      background: ${colors.white};
      content: '\\2714';
      color: ${colors.brand2};
      font-size: 16px;
    }
    &:checked::after {
      background: ${colors.white};
      content: '\\2714';
      color: ${colors.black};
      font-size: 16px;
    }
  }
  .FilterSelect_wrapper-active .FilterSelect_title {
    &::after {
      border-top: 8px solid transparent !important;
      border-bottom: 8px solid ${colors.brand2} !important;
      top: 42%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/UIFilterBar.js